import { memo as Memo } from 'react'
import _ from 'lodash'
import safeTemplate from '@/helpers/_safeTemplate'

//* Context
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer'

const Translate = Memo((props) => {
    const translationString = props.languages[props.selectedLang]?.[props.val]
    const compiled = translationString && safeTemplate(translationString)
    return (compiled && compiled(props.vars)) || props.val || null
})

export default withLanguageContext(Translate, '*')
